import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {Resource} from '../../../resource/resource';
import {EnvironmentConfigService} from '../../../core/services/environment-config.service';
import {Observable, of} from 'rxjs';
import {catchError, map, shareReplay} from 'rxjs/operators';
import {ResourceService} from '../../../resource/resource.service';
import {CacheService} from '../../../cache/cache.service';

@Component({
  selector: 'timeline-childrequest-table',
  templateUrl: './childrequest-table.component.html',
  styles: [
    'td, th { padding: 0 0.5rem; border-bottom: 1px solid var(--mat-sys-outline, rgba(0, 0, 0, 0.12)); }',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChildrequestTableComponent {
  constructor(
    private changeDetector: ChangeDetectorRef,
    private resourceService: ResourceService,
    private cacheService: CacheService,
    private envConfig: EnvironmentConfigService,
  ) {
    this.columnNames = this.cacheService
      .getDisplayAttributes(
        [
          this.envConfig.getAttributeName('DisplayName'),
          this.envConfig.getAttributeName('Operation'),
          this.envConfig.getAttributeName('CreatedTime'),
          this.envConfig.getAttributeName('RequestStatus'),
        ],
        this.envConfig.getObjectTypeName('Request'),
      )
      .pipe(map(das => das?.map(da => ResourceService.convertCamelCaseToNormal(da.DisplayName))));
  }

  requests: Observable<any[]> = null;

  columnNames: Observable<string[]>;

  @Output() openDetail: EventEmitter<any> = new EventEmitter();

  @Output() itemCount: EventEmitter<Observable<number>> = new EventEmitter<Observable<number>>();

  // Getter for template access to environment attributes
  get myEnv() {
    return {
      Attributes: {
        ObjectID: this.envConfig.getAttributeName('ObjectID'),
        DisplayName: this.envConfig.getAttributeName('DisplayName'),
        Operation: this.envConfig.getAttributeName('Operation'),
        CreatedTime: this.envConfig.getAttributeName('CreatedTime'),
        RequestStatus: this.envConfig.getAttributeName('RequestStatus'),
        ParentRequest: this.envConfig.getAttributeName('ParentRequest'),
      },
    };
  }

  @Input() set request(value: Resource) {
    const guid = value[this.envConfig.getAttributeName('ObjectID')];
    const filter =
      '/' +
      this.envConfig.getObjectTypeName('Request') +
      '[' +
      this.envConfig.getAttributeName('ParentRequest') +
      '="' +
      guid +
      '"]';
    const attributes = [
      this.envConfig.getAttributeName('ObjectID'),
      this.envConfig.getAttributeName('DisplayName'),
      this.envConfig.getAttributeName('Operation'),
      this.envConfig.getAttributeName('CreatedTime'),
      this.envConfig.getAttributeName('RequestStatus'),
    ]
      .filter(x => x != null)
      .join(',');
    this.requests = this.resourceService.searchResources(filter, attributes, 99999).pipe(
      map(x => (x == null ? [] : x.Results)),
      catchError(() => of([])),
      shareReplay(1),
    );
    this.itemCount.emit(this.requests.pipe(map(x => x.length)));
    this.changeDetector.markForCheck();
  }
}
